import { EmailDetailsModel } from "@core/services/api.service";


// //start
export class CreateEmailtrigger {
   static readonly type = '[Email trigger] Save email trigger details';

   constructor(public tourId: number) { }
}

export class CreateEmailtriggerSuccessAction {
   static readonly type = '[Email trigger] Save email trigger details Success';

   constructor(public payload: { emailDetails: EmailDetailsModel }) { }
}

 export class CreateEmailtriggerFailAction {
   static readonly type = '[Email trigger] Save email trigger details Fail';
 }
//end
